// Japanese (polite です/ます, as the Just One Interview pages) of the two
// candidate pages. Same sections and the same facts as the English master in
// lib/native/candidateEn.js. Change the English source first.
// Dates are written 2026年10月22日; the "(英語)" marker follows links to English pages.
const GOOGLE_BLOG_URL = "https://blog.google/company-news/outreach-and-initiatives/grow-with-google/interview-warmup/";

export const meta = {
  code: "ja",
  hreflang: "ja",
  nativeName: "日本語",
  banner: "このページは日本語でもご覧いただけます",
  switcherLabel: "言語",
  faqTitle: "よくある質問",
  footerPrivacy: "プライバシーポリシー(英語)",
  footerContact: "お問い合わせ",
};

export const pages = {
  "interview-warmup": {
    title: "Google Interview Warmup は終了。面接練習 AI を無料で",
    description:
      "Google は 2026年4月に Interview Warmup を終了しました。代わりに Just One Interview で、AI 面接官を相手に声に出して面接練習ができます。無料で始められ、点数付きレポートが届きます。",
    kicker: "面接のウォームアップ",
    h1: "Google Interview Warmup は終了しました。\nこのウォームアップは、声で応えてくれます。",
    lead:
      "面接練習アプリ Just One Interview の無料面接ウォームアップです。AI 面接官と声で会話し、質問はあなたが選んだ職種とスキルから作られ、終わると点数付きのレポートが届きます。カメラを使うかどうかはあなたが決められます。セッションがビデオで録画されるのは、カメラがオンで、あなたが同意しているあいだだけです。",
    note:
      "Google は 2026年4月に Interview Warmup を終了し、以前のアドレスでは開けなくなりました。[何が起きたのか、代わりに何を使えばよいか](/blog/google-interview-warmup-alternatives)(英語)。",
    cta: "無料で始める →",
    blocks: [
      {
        type: "answer",
        title: "Google Interview Warmup はまだ使えますか?",
        paragraphs: [
          "いいえ。Google は 2026年4月に Interview Warmup を終了し、以前のアドレスではこのツールは開けなくなりました。2026年10月22日に grow.google/interview-warmup を開いたところ、私たちの地域向けの Grow with Google のホームページに移動しました。そのページには、キャリア向けのコースと認定資格が並んでいて、Interview Warmup は載っていません。表示される内容は、国によって異なる場合があります。",
          "声に出して練習できる無料の方法として、Just One Interview は無料で始められ、カードの登録も求められません。[ほかの無料の選択肢との比較を見る](#free-tools)か、[終了についての情報源を確認する](#status)こともできます。",
        ],
      },
      {
        type: "text",
        title: "Google Interview Warmup とは何でしたか?",
        paragraphs: [
          "Google Interview Warmup は、面接の質問を練習するための Grow with Google のツールでした。Google が発表したのは 2022年6月2日です。業界の専門家が選んだ質問に答えると、ツールが話した内容をそのまま文字に起こし、使った仕事関連の用語、よく使った言葉、各回答の話のポイントなどを表示しました。点数はつけず、本番の面接の前に自信を持てるようにするためのものでした。",
          `Google Career Certificate の受講者向けに、認定資格ごとの質問セットが用意されていました。一方で誰でも使えて、多くの分野向けの一般的な質問もありました。[Google 自身の発表](${GOOGLE_BLOG_URL})(英語)をお読みください。`,
          "Google のウォームアップのページを探す検索は、ウェブサーバーのキャッシュやメールのドメインのウォームアップを指すこともあります。このページで扱うのは、面接練習のツールです。",
        ],
      },
      {
        type: "text",
        badge: "聞いてくれるウォームアップ",
        title: "声で応えてくれる AI を相手に、声に出して練習する",
        paragraphs: [
          "入力欄に文字で答えを打つのは、面接練習とは言えません。Just One Interview では、あなたが話し、AI 面接官が聞いて声で返します。本番の一次面接と同じ程度の、ほどよい緊張感が生まれます。",
        ],
        points: ["入力なしの、実際の音声での会話", "話しているあいだに表示される、会話のライブ書き起こし"],
      },
      {
        type: "text",
        badge: "どんな職種でも",
        title: "あなたの職種名そのままの質問",
        paragraphs: [
          "受ける職種を入力し、練習したいスキルを加え、手元にあれば求人票を貼り付けてください。Just One Interview は、入力した内容から質問を作ります。経理アシスタントでも、スタッフエンジニアでも同じです。",
        ],
      },
      {
        type: "text",
        badge: "点数付きレポート",
        title: "励ましではなく、回答ごとの点数",
        paragraphs: [
          "セッションが終わると、数分以内にレポートが届きます。質問ごとに点数がつき、あなたが話した内容が引用され、うまくいった点と直す点が示され、いくつかの回答にはより強い言い方も提案されます。練習して、読んで、一つ直して、もう一度。その繰り返しです。",
        ],
      },
      {
        type: "text",
        badge: "あなたの選択",
        title: "カメラのオンもオフも、あなたが決めます",
        paragraphs: [
          "Just One Interview が練習セッションをビデオで録画するのは、カメラがオンのあいだだけで、セッションの前に録画への同意のチェックボックスにチェックを入れた場合に限ります。カメラをオフにすれば、ビデオは録画されません。練習の録画を共有することはできず、レポートではカメラのオンオフにかかわらずフィラーワードが数えられます。準備ができたら The One を録画し、見返して、採用チームに送るかどうかを選べます。",
        ],
      },
      {
        type: "text",
        badge: "無料で始められます",
        title: "本番の直前でもウォームアップ",
        paragraphs: [
          "セッションの長さはあなたが選び、パソコンでもスマートフォンでもブラウザ上で動きます。Just One Interview は無料で始められるので、本番の面接の前に、一回分のセッションを最後まで終えて、点数付きレポートを読むことができます。",
        ],
      },
      {
        type: "table",
        id: "status",
        title: "Interview Warmup の情報源と現在の状況",
        paragraphs: ["2026年10月22日に確認した内容と、各情報源が示していること、示していないことをまとめました。"],
        head: ["情報源", "2026年10月22日時点の状況", "リンク", "わかること"],
        rows: [
          [
            "以前の Grow with Google のページ",
            "ツールは開きません。Grow with Google のホームページに移動しました。",
            "[grow.google/interview-warmup](https://grow.google/interview-warmup)",
            "私たちが確認した場所からは、以前のアドレスは練習ツールにつながりませんでした。ほかの国では動作が異なる可能性があります。",
          ],
          [
            "Google の 2022年の発表",
            "今もオンラインにあります",
            `[blog.google、Helping job seekers prepare for interviews](${GOOGLE_BLOG_URL})`,
            "ツールが何で、どう動いていたか。2022年に書かれたものなので、ツールの終了については何も書かれていません。",
          ],
          [
            "Grow with Google のホームページ",
            "開きます",
            "[grow.google](https://grow.google/)",
            "Grow with Google は今もキャリア向けのコースと認定資格を提供しています。私たちが開いたページには Interview Warmup は載っていませんでした。",
          ],
          [
            "Google ヘルプのページ",
            "Interview Warmup についてのヘルプページは見つかりませんでした",
            "ページなし",
            "ツールの終了についての Google からのお知らせは見つかりませんでした。",
          ],
        ],
      },
      {
        type: "table",
        id: "free-tools",
        title: "AI で面接の準備をする無料の方法",
        paragraphs: [
          "Just One Interview は無料で始められ、カードの登録は求められません。そのほかの種類のツールは無料の範囲が変わるので、計画に組み込む前に、それぞれのツールのページをお読みください。この表は、種類ごとの向き不向きを示しています。",
        ],
        head: ["選択肢", "無料プラン", "音声での練習", "職種に合わせた質問", "フィードバック", "向いている使い方"],
        rows: [
          ["汎用の AI チャットボット", "各ツールのページをご確認ください。制限は変わります。", "ツールによって異なります", "貼り付けた求人票の内容までしか合わせられません", "チャットでの文章によるコメント。依頼しなければ決まった点数はつきません", "質問のアイデア出しと、STAR 形式の回答の下書き"],
          ["Just One Interview", "無料で始められ、カードは不要です。毎月の練習枠があります。", "あります。あなたが話し、AI 面接官が声で返します。パソコンでもスマートフォンでもブラウザで動きます", "あります。職種とスキルを入力でき、求人票も貼り付けられます", "点数付きレポート。総合点、質問ごとの点数、強み、改善点、模範解答、フィラーワードの数", "追加の質問がある、本格的な音声の模擬面接"],
          ["Google Interview Warmup", "提供されていたあいだは誰でも使えました。以前のアドレスでは、もう開きません。", "あります。声で答えると、回答が文字に起こされました", "Google Career Certificate ごとの質問セットと、一般的な質問", "仕事関連の用語、よく使った言葉、話のポイントについての分析。点数はなし", "提供されていたころの、手軽な予行演習"],
          ["音声ロールプレイのツール", "各ツールのページをご確認ください。制限は変わります。", "あります。場面設定に沿って話します", "ツールによって異なります", "ツールによって異なります", "リクルーターとの電話やお客様との通話など、会話の練習"],
          ["スピーチコーチングのツール", "各ツールのページをご確認ください。制限は変わります。", "あります", "重点ではありません。話し方を見ます", "話し方について:話すペース、フィラーワード、わかりやすさ", "回答の中身は良いのに、話し方で損をしているとき"],
          ["技術面接の模擬ツール", "各ツールのページをご確認ください。制限は変わります。", "ツールによって異なります。ライブコーディングやホワイトボードのセッションが多いです", "あります。技術的なテーマについて", "ツールによって異なります:コードの実行、仲間、専門家など", "コーディングとシステム設計の練習"],
        ],
      },
      {
        type: "table",
        id: "choose",
        title: "AI 面接練習ツールの選び方",
        paragraphs: [
          "あなた自身の職種から質問を作り、追加の質問をし、あなたが実際に話した内容に結びついたフィードバックをくれるツールを選びましょう。どのツールにも、このチェックリストが使えます。右の列は、Just One Interview の対応です。",
        ],
        head: ["確認すること", "なぜ大切か", "Just One Interview"],
        rows: [
          ["あなたの職種や求人票から作られる質問", "一般的な質問では、実際に受ける面接と合いません。", "職種とスキルを入力し、求人票も貼り付けられます。質問は入力した内容に沿います。"],
          ["受ける面接で使われる種類の質問", "行動面接、技術面接、職種別の質問では、必要な練習が違います。", "セッションを設定するときに、扱ってほしいスキルを伝えます。"],
          ["追加の質問", "本物の面接官は、答えが薄いと重ねて聞きます。", "答えが短かったり一般的だったりすると、AI 面接官が追加の質問をします。"],
          ["話した内容に結びついたフィードバック", "回答を引用したアドバイスのほうが、行動に移しやすくなります。", "レポートはあなたの回答を引用し、書き起こしも保存されます。"],
          ["回答ごとの点数", "どの回答から直すべきかがわかります。", "レポートには総合点と質問ごとの点数があり、強み、改善点、模範解答もつきます。"],
          ["あとで使えるメモ", "セッションを比べて、何が変わったかを確認できます。", "過去の練習レポートは、あなたのアカウントに残ります。"],
          ["入力ではなく、声での回答", "話すペースやフィラーワードは、声に出したときにしか表れません。", "あなたが話し、フィラーワードが数えられます。"],
          ["わかりやすい無料の範囲", "無料の範囲を見て、練習の計画を立てられます。", "カード不要で無料で始められ、毎月の練習枠があります。"],
        ],
        after: [
          "練習ではなく採用する側で、書き起こしを採点して構造化された面接メモを作るツールをお探しですか。その場合はチェックリストが変わります。正確な書き起こし、職種に合わせて作られた基準による採点、各点数の根拠、質問ごとにまとめられたメモ、お使いの ATS との相性を見てください。AI Interview Agents は、候補者の発言に結びついた理由つきの点数と書き起こしを提供し、ATS との連携は Greenhouse からの一方向のインポートだけです。[採用担当者向けの AI 面接官](/recruiters/ai-interviewer)(英語)をご覧ください。",
        ],
      },
    ],
    faq: [
      {
        q: "Google Interview Warmup はまだ使えますか?",
        a: "いいえ。Google は 2026年4月に Interview Warmup を終了し、以前のアドレスではもう開きません。声に出して練習したい方には、面接練習アプリの Just One Interview をご案内しています。無料で始められます。AI 面接官と話し、終わると点数付きのレポートが届きます。",
      },
      {
        q: "この面接ウォームアップは無料ですか?",
        a: "はい。Just One Interview は無料で始められ、登録にカードは求められません。",
      },
      {
        q: "ChatGPT や Gemini で練習するのとは、どう違いますか?",
        a: "チャットアシスタントは文字で返します。Just One Interview では、AI 面接官が質問を声で読み上げ、あなたの答えを聞きます。終わると、点数付きのレポートが届きます。練習セッションがビデオで録画されるのは、カメラがオンで、あなたが同意しているあいだだけで、カメラはオフにできます。",
      },
      {
        q: "どんな職種でウォームアップできますか?",
        a: "入力できる職種名ならどれでも使えます。練習したいスキルを加え、求人票を貼り付けることもできます。Just One Interview には、企業別の質問ページもあり、そこから練習できます。",
      },
      {
        q: "Google Interview Warmup とは何でしたか?",
        a: "Google Interview Warmup は、面接の質問を練習するための Grow with Google のツールでした。Google が発表したのは 2022年6月2日です。業界の専門家が選んだ質問に答えると、回答が文字に起こされ、使った仕事関連の用語、よく使った言葉、各回答の話のポイントなどが表示されました。点数はつきませんでした。Google Career Certificate の受講者向けに作られ、誰でも使えました。",
      },
      {
        q: "AI で面接の準備をするのに使える無料のツールには、何がありますか?",
        a: "ツールは五種類あります。汎用の AI チャットボット、音声の模擬面接アプリ、音声ロールプレイのツール、スピーチコーチングのツール、技術面接の模擬プラットフォームです。音声の模擬面接アプリである Just One Interview は、カード不要で無料で始められます。そのほかは無料の範囲が変わるので、頼りにする前にそれぞれのツールのページをお読みください。このページの比較表に、種類ごとの向き不向きがあります。",
      },
      {
        q: "AI 面接練習ツールには、どんな機能が必要ですか?",
        a: "あなたの職種や求人票から作られる質問、行動面接と技術面接の練習、追加の質問、話した内容に結びついたフィードバック、回答ごとの点数、あとで使えるメモを探してください。Just One Interview は、入力した職種とスキル、貼り付けた求人票から質問を作り、追加の質問をし、質問ごとの点数、強み、改善点、模範解答、フィラーワードを含む点数付きレポートを提供します。練習は英語で行われます。全項目のチェックリストはこのページにあります。",
      },
      {
        q: "リンクが見つかりません。どのリンクをお探しですか?",
        a: "Google Interview Warmup をお探しなら、以前のアドレスである grow.google/interview-warmup では、もうツールは開きません。練習したい場合は、このページの「無料で始める」ボタンから、無料で始められる Just One Interview が開きます。面接の招待のことでしたら、迷惑メールフォルダも含めてメールを確認し、企業に再送を依頼してください。それでも開かない場合は、試したリンク、表示されたエラーの内容、お使いの端末を添えて contact@aiinterviewagents.com までご連絡ください。",
      },
    ],
    closing: {
      title: "Just One Interview で練習する",
      text: "無料で始められ、カードは求められません。職種を入力し、スキルを加えて、話し始めましょう。",
      button: "無料で始める",
    },
  },

  "ai-video-interview": {
    title: "AI 録画面接・Web 面接の練習を無料で | AI ビデオ面接",
    description:
      "Just One Interview で AI ビデオ面接の練習が無料でできます。カードは不要。AI 面接官と話し、点数付きレポートを受け取れます。カメラは任意で、録画されるのはカメラがオンで、あなたが同意しているあいだだけです。",
    h1: "AI ビデオ面接の練習:カメラをオンにして、本物の会話を",
    lead:
      "AI ビデオ面接では AI 面接官と話し、実際の採用面接では、たいてい録画されます。練習には、面接練習アプリの Just One Interview をお使いください。AI があなたの選んだ職種から質問を作り、終わると詳しいレポートが届きます。練習セッションがビデオで録画されるのは、カメラがオンで、あなたが同意しているあいだだけです。",
    cta: "無料で練習を始める →",
    blocks: [
      {
        type: "text",
        title: "AI を使ったビデオ面接とは?",
        paragraphs: [
          "AI を使ったビデオ面接とは、AI が進行や評価を行うオンラインの採用面接のことで、あらかじめ決められた質問への録画回答が使われることも多いです。ソフトウェアが回答を文字に起こしたり、要約したり、候補者に点数をつけたり順位をつけたり、話し方を評価したりし、採用担当者が結果を見て、次に進む人を決めます。",
          "企業は、多くの応募者を、より一貫した方法でふるいにかけるために使います。一方向の録画のものもあれば、AI 面接官とのライブの会話もあり、どちらになるかによって、聞かれる内容と採点される内容が変わります。",
        ],
      },
      {
        type: "text",
        title: "AI ビデオ面接の多くは、一方向の録画です",
        paragraphs: [
          "多くの AI ビデオ面接ツールには、こんな問題があります。自分に向かって話すだけの録画なのです。画面に出た質問を読み、一方向のビデオで答えを録画し、モデルがその映像を採点します。これは本物の面接のやり方ではありません。本物の面接は会話です。面接官はあなたの言葉に反応し、弱いところを突き、強い答えをさらに掘り下げ、あなたの本当の実力が出るような緊張感を生み出します。",
          "AI Interview Agents は、その代わりに双方向のビデオ面接を行います。音声で聞いて音声で答える AI 面接官がリアルタイムで話し、キーワードの照合ではなく回答の中身を理解し、あなたの発言に基づいて次の質問をします。練習用の Just One Interview では、カメラをオンにして声で会話します。セッションがビデオで録画されるのは、カメラがオンで、あなたが同意しているあいだだけで、フィードバックは点数付きレポートで届きます。",
        ],
      },
      {
        type: "table",
        title: "シンプルな AI ビデオ面接ツール",
        paragraphs: [
          "Spark Hire は、候補者がいつでも答えられる一方向のビデオ面接を始めるのに手軽なサービスで、料金を公開し、月単位で契約できます。一方向の面接では、候補者ごとにリンクと決められた質問が届き、都合のよいときに回答を録画するので、通話の日程調整は不要です。",
          "面接の練習をしたい方は、「職種からレポートまで、ひと息で」へお進みください。この表は、採用のためのツールを選ぶ方向けです。",
        ],
        head: ["ツール", "種類", "公開されている料金(2026年10月22日に確認)", "出典"],
        rows: [
          ["Spark Hire", "一方向とライブのビデオ面接", "年払いで月額$249から、月払いで月額$299から。料金は企業の規模によって変わります。", "[sparkhire.com/pricing](https://www.sparkhire.com/pricing/)"],
          ["Hireflix", "一方向のビデオ面接", "従業員50人未満の企業向けで月額$150、年払いなら月額$75。最初の一か月は無料です。", "[hireflix.com/pricing](https://hireflix.com/pricing)"],
          ["Interviewer.AI", "評価レポート付きの録画ビデオ面接と、会話型の AI 面接", "月額$199から。14日間の無料トライアルがあります。", "[interviewer.ai/pricing](https://interviewer.ai/pricing/)"],
          ["HireVue", "AI による面接とスクリーニング", "料金は非公開です。料金ページは問い合わせフォームになっています。", "[hirevue.com/pricing](https://www.hirevue.com/pricing)"],
        ],
        after: [
          "この検索では、OneWayInterview.com と TestGorilla も出てきます。これらのプランは確認していないので、各社のサイトをご覧ください。料金は変わりますので、購入の前に各社のページで確認してください。",
          "一方向のツールは、追加の質問ができません。聞いて、追加の質問もしてくれる AI 面接官をお探しなら、[採用担当者向けの AI ビデオ面接ソフトウェア](/recruiters/ai-video-interview-software)や[ベンダー比較](/compare)(英語)をご覧ください。",
        ],
      },
      {
        type: "steps",
        title: "職種からレポートまで、ひと息で",
        steps: [
          {
            title: "ステップ1:職種を選ぶ",
            text: "準備している職種を入力します。シニアプロダクトマネージャーやジュニアメカニカルエンジニアなど、何でも構いません。練習したいスキルを加え、求人票を貼り付けることもできます。Just One Interview は、入力した内容から質問を作ります。",
          },
          {
            title: "ステップ2:会話をする",
            text: "声で会話をします。AI 面接官が質問を声で読み上げてあなたの答えを聞き、答え終わったらボタンをタップします。セッションの長さはあなたが選びます。ビデオが録画されるのは、カメラがオンで、先にあなたが同意した場合だけです。",
          },
          {
            title: "ステップ3:レポートを受け取る",
            text: "終わって数分後にレポートが届きます。点数、うまくいった点、直す点、いくつかの回答のより強い言い方が示されます。過去の練習レポートはアカウントに残るので、見比べられます。",
          },
        ],
      },
      {
        type: "chips",
        title: "IT 職だけでなく、どんな職種でも練習できます",
        paragraphs: [
          "ソフトウェアエンジニアはもちろん、パティシエ、海洋生物学者、営業部長、投資銀行のアナリスト、UX デザイナー、サプライチェーンマネージャー、臨床心理士もです。Just One Interview では職種名をご自身で入力するので、練習できない職種はありません。",
        ],
        items: ["ソフトウェアエンジニア", "データアナリスト", "マーケティング", "プロダクトマネージャー", "UX デザイナー", "心理士", "理容師"],
      },
      {
        type: "text",
        title: "双方向の AI ビデオ面接は、どこが違うのか",
        paragraphs: [],
      },
      {
        type: "box",
        title: "AI ビデオ面接は、どのように行われますか?",
        text: "企業が候補者にリンクを送り、候補者がビデオで答え、ソフトウェアが回答を書き起こしと点数付きの要約にして、採用担当者が確認します。よくある形式は二つです。一方向の非同期面接では、候補者が決められた質問への回答を好きなときに録画します。AI が補助するライブ面接では、AI 面接官がリアルタイムで質問し、追加の質問もできます。ツールによって、ソフトウェアは回答を書き起こし、分析し、点数、要約、タグ、候補者の絞り込みを作ります。結果は多くの場合、人間の採用担当者が確認し、次の選考に進む人を決めます。",
      },
      {
        type: "table",
        head: ["形式", "双方向", "フィードバック", "録画", "どんな職種でも"],
        rows: [
          ["Just One Interview の練習", "はい", "点数付きレポート", "カメラがオンで、あなたが同意した場合のみ", "入力したどんな職種でも"],
          ["一方向のビデオ録画", "いいえ", "基本的な点数", "ビデオで", "限られます"],
          ["テキストやチャットでの練習", "いいえ", "基本的なもの", "なし", "限られます"],
          ["鏡の前での練習", "いいえ", "なし", "なし", "どんな職種でも"],
          ["人間による、ライブの模擬面接", "はい", "専門家から", "まれに", "場合によります"],
        ],
      },
      {
        type: "text",
        title: "学生、転職を考える方、面接の準備をするすべての方のために",
        paragraphs: [
          "キャンパス採用の選考に備える学生、未経験の業界に向けて練習する転職希望者、シニア向けの選考に向けて肩慣らしをする経験者、そしてカメラの前で緊張する人。終わって数分後にレポートが届く、構造化された練習は、そのすべての人に役立ちます。採用で自社の AI ビデオ面接を行う企業が増えているので、本番の前にその形式を練習しておくことは、自分に与えられるいちばん手軽な強みです。",
          "数分しかありませんか。それなら、手軽な[面接ウォームアップ](/ja/features/interview-warmup)をどうぞ。AI ビデオ面接を実施したい採用チームの方は、[採用担当者向けの AI ビデオ面接ソフトウェア](/recruiters/ai-video-interview-software)(英語)をご覧ください。",
        ],
      },
    ],
    faq: [
      {
        q: "AI ビデオ面接とは何ですか?",
        a: "AI 面接官がビデオで行う採用面接のことです。双方向の AI ビデオ面接では、AI とリアルタイムで話します。AI が質問し、聞いて、追加の質問をします。企業の面接は、採点したり見返したりできるように録画されます。Just One Interview での練習セッションがビデオで録画されるのは、カメラがオンで、あなたが同意しているあいだだけです。",
      },
      {
        q: "AI ビデオ面接の練習は、どうすればよいですか?",
        a: "Just One Interview で、職種名を入力し、スキルを加え、あれば求人票を貼り付けます。セッションの長さを選び、声に出して答えます。終わると点数付きのレポートが届きます。ビデオが録画されるのは、カメラがオンで、先にあなたが同意した場合だけで、無料で始められます。",
      },
      {
        q: "AI ビデオ面接では録画されますか?",
        a: "実際の採用面接では、たいてい録画され、採用担当者がその録画を見ます。Just One Interview での練習がビデオで録画されるのは、カメラがオンのあいだだけで、録画への同意のチェックボックスにチェックを入れたあとに限ります。カメラをオフにすれば、ビデオは録画されません。練習の録画は共有できません。準備ができたら The One を録画し、見返して、送るかどうかを選べます。",
      },
      {
        q: "AI ビデオ面接で良い結果を出すには?",
        a: "声に出して、文章で完結するように答え、状況、行動、結果の順で答えを組み立て、一般論ではなく具体例を出してください。AI が採点するのはキーワードではなく中身です。二、三回練習すると、形式への不安の大半はなくなります。",
      },
      {
        q: "AI はビデオ面接を分析できますか?",
        a: "はい。ツールによっては、AI が候補者の発言を書き起こし、回答の内容、わかりやすさ、構成、話すペースを評価できます。声の特徴や視覚的な手がかりも見るツールや、求人の基準に照らして回答を採点するツールもあります。声や映像の分析はいちばん議論の多い部分で、偏りが生じる可能性があり、信頼性もまちまちで、公平性は現実の懸念です。そのため、結果は人が確認すべきです。AI Interview Agents は、候補者が話した内容の書き起こしを採点し、顔や表情の分析は行いません。",
      },
      {
        q: "AI ビデオ面接は、どのように行われますか?",
        a: "企業が候補者にリンクを送ります。一方向の面接では、候補者が決められた質問への回答を好きなときに録画します。ライブの面接では、AI 面接官がリアルタイムで質問し、追加の質問もできます。ソフトウェアが書き起こしを作り、回答を分析、要約、採点したり、タグをつけて候補者の絞り込みを作ったりすることがあり、たいていは採用担当者が結果を確認して、次に進む人を決めます。",
      },
      {
        q: "AI を使ったビデオ面接とは何ですか?",
        a: "AI が進行や評価を行うビデオでの採用面接で、あらかじめ決められた質問への録画回答が使われることも多いです。ソフトウェアが、文字起こし、要約、採点、順位づけ、コミュニケーションの質の評価を行うことがあり、結果は採用担当者が確認します。",
      },
      {
        q: "AI ビデオ面接は無料ですか?",
        a: "練習は無料で始められます。Just One Interview はカードを求めず、パソコンでもスマートフォンでもブラウザで動き、毎月の練習枠があります。実際の採用でのビデオ面接は企業が設定し、招待された候補者にはアカウントも、ライセンスも、インストールも必要ありません。採用する側の方には、AI Interview Agents に無料プランがあり、各プランの内容は料金ページに載っています。",
      },
      {
        q: "面接をするのは誰ですか?",
        a: "このページでは AI 面接官です。Just One Interview の練習セッションでは、AI が質問を声で読み上げ、あなたの答えを聞きます。実際の企業の面接はツールによります。決められた質問が表示されて録画するものもあれば、ライブの AI 面接官を使うものもあります。多くの場合、あとで採用担当者や採用マネージャーが結果を確認して判断します。AI Interview Agents では、面接官は AI で、判断は採用チームの人が行います。",
      },
      {
        q: "使いやすい AI ビデオ面接ツールはどれですか?",
        a: "使いやすいツールとは、料金を公開し、月単位で契約でき、一方向の録画回答を使うので、通話の日程調整が不要なものです。Spark Hire がこれに当てはまります。2026年10月22日に確認した料金ページには、年払いで月額$249から、月払いで月額$299からのプランがあり、料金は企業の規模によって変わると書かれています。代わりになるのは Hireflix、Interviewer.AI、HireVue で、OneWayInterview.com と TestGorilla も出てきますが、これらのプランは確認していません。候補者に追加の質問をしてほしい場合は、AI Interview Agents のような、双方向の AI 面接官を使ってください。",
      },
    ],
    closing: {
      title: "最初の練習セッションを始める",
      text: "好きな職種を選び、カメラをオンにして AI 面接官と話しましょう。終わると点数付きレポートが届きます。無料で始められ、カメラをオンにするかどうかはあなたが決めます。",
      button: "練習を始める",
    },
  },
};
